module.exports = __webpack_public_path__ + "static/media/binge-banner.5d229b30.jpg";